import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SessionProvider } from './api/session.jsx';
import { Visionneuse } from './components/Visionneuse.jsx';
import { PageInvitation } from './features/public/PageInvitation.jsx';
import { OuverturePdf } from './features/public/OuverturePdf.jsx';
import { PhotoEnGrand } from './features/public/PhotoEnGrand.jsx';
import { PagePublique } from './features/public/PagePublique.jsx';
import { PageAccesClient } from './features/portail/PageAccesClient.jsx';
import { Racine } from './features/portail/Racine.jsx';
import {
  jetonDAccesClient,
  jetonDInvitation,
  jetonDeLaPage,
  jetonDuPdf,
  photoDeLaPage,
} from './lib/lien-public';
import './index.css';
import { declarePolices } from './lib/polices-ecran';
import { enregistreServiceWorker } from './pwa/enregistrement';
import { ecouteInstallation } from './pwa/installation';
import { lisOuvrierDeLAdresse } from './lib/appareil-ouvrier';
import { poseLeBordDuHaut } from './lib/bord-haut';

// Avant le premier rendu : le navigateur propose l'installation tres tot, et
// le service worker n'est enregistre qu'en production (voir enregistrement.js).
ecouteInstallation();
// Les polices choisies pour les documents (Réglages → Écriture des documents).
declarePolices();
enregistreServiceWorker();
// L'icône installée depuis une invitation rouvre « /?ouvrier=CODE.12 » :
// l'écran de connexion s'ouvre au nom de l'ouvrier, tant que le code ouvrier vaut.
lisOuvrierDeLAdresse();
// Sous Safari d'iPhone, l'en-tête descend sous la bande que Safari floute.
poseLeBordDuHaut();

// Le lien remis a un client mene a sa piece, non a l'application : il n'a pas
// de compte, et rien de la session ni des donnees de l'entreprise ne se charge.
const jeton = jetonDeLaPage(window.location.pathname);
// Le bouton « Ouvrir … en PDF » de l'e-mail d'envoi : le PDF s'ouvre, et le
// bureau le sait.
const pdf = jetonDuPdf(window.location.pathname);
// Une photo touchée dans le PDF d'une offre ou d'une facture : en grand.
const photo = photoDeLaPage(window.location.pathname);
// L'invitation d'un employe mene de meme a sa page, sans session : c'est la
// qu'il choisit son adresse et son mot de passe, puis saisit le code recu.
const invitation = jetonDInvitation(window.location.pathname);
// L'invitation à l'espace client du magasin : la personne y crée son compte.
const accesClient = jetonDAccesClient(window.location.pathname);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Visionneuse />
    {jeton ? (
      <PagePublique jeton={jeton} />
    ) : pdf ? (
      <OuverturePdf jeton={pdf} />
    ) : photo ? (
      <PhotoEnGrand jeton={photo.jeton} numero={photo.numero} />
    ) : invitation ? (
      <PageInvitation jeton={invitation} />
    ) : accesClient ? (
      <PageAccesClient jeton={accesClient} />
    ) : (
      <SessionProvider>
        <Racine />
      </SessionProvider>
    )}
  </StrictMode>,
);
